import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
import React from 'react';
import classNames from 'classnames';
var css = {
  "listItem": "rui-ILEMQ",
  "tabTitle": "rui-SsoSp",
  "selected": "rui-ufJct"
};
var TabTitle = /*#__PURE__*/function (_React$Component) {
  _inherits(TabTitle, _React$Component);
  var _super = _createSuper(TabTitle);
  function TabTitle(props) {
    var _this;
    _classCallCheck(this, TabTitle);
    _this = _super.call(this, props);
    _this.bindings = {
      onClick: _this.onClick.bind(_assertThisInitialized(_this))
    };
    return _this;
  }
  _createClass(TabTitle, [{
    key: "onClick",
    value: function onClick(event) {
      this.props.onClick({
        id: this.props.id
      }, event);
    }
  }, {
    key: "render",
    value: function render() {
      var classes = [css.tabTitle, this.props.selected && (this.props.selectedClass || css.selected), this.props.className];
      var dataAutId = this.props['data-aut-id'];
      var listStyle = Object.assign(Object.assign({}, this.props.style), this.props.selected ? this.props.selectedStyle : {});
      return /*#__PURE__*/React.createElement("li", {
        className: classNames(css.listItem, this.props.listItemClassName)
      }, /*#__PURE__*/React.createElement("div", {
        "data-aut-id": dataAutId,
        onClick: this.bindings.onClick,
        onKeyPress: this.bindings.onClick,
        tabIndex: 0,
        className: classNames(classes),
        style: listStyle,
        role: "button"
      }, this.props.children));
    }
  }]);
  return TabTitle;
}(React.Component);
TabTitle.defaultProps = {
  id: 0,
  style: {},
  onClick: function onClick() {},
  selected: false,
  className: '',
  listItemClassName: '',
  selectedStyle: {},
  selectedClass: '',
  'data-aut-id': 'tabTitle'
};
export default TabTitle;